export default __webpack_public_path__ + "alberta-fab-send.ca90c3157346582a51af.svg";